(function($) {
	'use strict';

	var $loginButton = $('[data-checkout-tab-button]');

	$loginButton.each(function() {
		var $this = $(this);
		$this
			.attr('href', '#' + $this.attr('aria-controls'))
			.on('click', showLoginForm);
	});

	function showLoginForm(e) {
		e.preventDefault();
		$(e.target).tab('show');
		return false;
	}

})($jq);
